export default __webpack_public_path__ + "step-arrow-desktop.svg";